// eslint-disable-next-line import/no-extraneous-dependencies
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { isRelease } from 'common/util/releaseGuard';

export const useIsVarianceTrackingEnabled = (): boolean => {
  const flagEnabled = useFeatureFlagEnabled('variance-tracking');
  return !!flagEnabled;
};
